var _path, _line, _line2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.306 27.3184H17.1393M5.84766 24.9017H23.5977C24.7022 24.9017 25.5977 24.0063 25.5977 22.9017V11.1934C25.5977 10.0888 24.7022 9.19336 23.5977 9.19336H5.84766C4.74309 9.19336 3.84766 10.0888 3.84766 11.1934V22.9017C3.84766 24.0063 4.74309 24.9017 5.84766 24.9017Z",
    stroke: "#1B0076",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.2388,
    y1: 8.64428,
    x2: 10.2388,
    y2: 2.64428,
    stroke: "#1B0076",
    strokeWidth: 2.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.2116,
    y1: 9.71903,
    x2: 18.2116,
    y2: 2.71903,
    stroke: "#1B0076",
    strokeWidth: 2.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.72266,
    cy: 1.65234,
    r: 1.5,
    fill: "#1B0076"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7227,
    cy: 1.65234,
    r: 1.5,
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.f67dac70.svg";
export { ForwardRef as ReactComponent };